// src/pages/VerifyEmailPage.tsx
import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { verifyEmailApi } from "../api/auth";
import { useTranslation } from "react-i18next";

const VerifyEmailPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">(
    "idle"
  );
  const [message, setMessage] = useState<string | null>(null);
  const { t } = useTranslation();

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      setMessage(t("verifyEmail.missingToken"));
      return;
    }

    setStatus("loading");
    verifyEmailApi(token)
      .then((res) => {
        setStatus(res.success ? "success" : "error");
        setMessage(
          res.message ||
            (res.success
              ? t("verifyEmail.successDefault")
              : t("verifyEmail.invalidOrExpired"))
        );
      })
      .catch((err: any) => {
        console.error(err);
        setStatus("error");
        setMessage(err.message || t("verifyEmail.genericError"));
      });
  }, [searchParams, t]);

  return (
    <section className="auth-landing">
      <div className="lp-container">
        <div className="auth-center">
          <div className="auth-card auth-card-verify">
            <h1 className="auth-card-title">{t("verifyEmail.title")}</h1>
            {status === "loading" && (
              <p className="auth-subtitle">{t("verifyEmail.loading")}</p>
            )}
            {status !== "loading" && message && (
              <p className="auth-subtitle">{message}</p>
            )}
            {(status === "success" || status === "error") && (
              <p className="auth-switch" style={{ marginTop: "1.25rem" }}>
                {t("verifyEmail.backToLogin")}{" "}
                <Link to="/login">{t("verifyEmail.loginLink")}</Link>.
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VerifyEmailPage;
